"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const get_1 = __importDefault(require("lodash/get"));
const moment_1 = __importDefault(require("moment"));
const subscriptionSlice_1 = require("../../../../redux/slices/subscriptionSlice");
const preloaderSlice_1 = require("../../../../redux/slices/preloaderSlice");
require("./billingHistory.scss");
const svgIcons_1 = require("../../../../svgIcons");
const billingItem_1 = __importDefault(require("./billingItem"));
const tableHead = [
    {
        key: "Date",
        value: "period_end"
    }, {
        key: "Billing Period",
        value: "billing_period"
    }, {
        key: "Amount",
        value: "amount"
    }, {
        key: "Actions",
        value: "invoice_pdf"
    }
];
const BillingHistory = (props) => {
    const { subscription: { invoices } } = props;
    react_1.useEffect(() => {
        props.showLoader();
        props.getList()
            .then(() => props.hideLoader())
            .catch(() => props.hideLoader());
    }, []);
    const getTableCell = (row, val, key) => {
        let cell = (react_1.default.createElement("span", null, get_1.default(row, val.value)));
        if (val.value === "period_end") {
            cell = (react_1.default.createElement("span", null, moment_1.default(get_1.default(row, val.value)).format('MM/DD/YYYY').toUpperCase()));
        }
        else if (val.value === "invoice_pdf") {
            cell = (react_1.default.createElement("a", { className: "download-btn", href: get_1.default(row, val.value) },
                react_1.default.createElement(svgIcons_1.DownloadIcon, null),
                react_1.default.createElement("span", null, "Download PDF")));
        }
        return (react_1.default.createElement(core_1.TableCell, { key: key, className: "" }, cell));
    };
    return (react_1.default.createElement(react_1.Fragment, null, (invoices === null || invoices === void 0 ? void 0 : invoices.length) > 0 &&
        react_1.default.createElement("div", { className: "clearfix billing-container" },
            react_1.default.createElement("h3", { className: 'page-title' }, "Billing History"),
            react_1.default.createElement(core_1.TableContainer, { className: "clearfix billing-history" },
                react_1.default.createElement(core_1.Table, { "aria-label": "table", className: "billing-table" },
                    react_1.default.createElement(core_1.TableHead, { className: "billing-table-thead" },
                        react_1.default.createElement(core_1.TableRow, null, tableHead.map((val, key) => react_1.default.createElement(core_1.TableCell, { key: key }, val.key)))),
                    react_1.default.createElement(core_1.TableBody, { className: "billing-table-tbody" }, invoices.map((row, key) => {
                        return (react_1.default.createElement(core_1.TableRow, { key: key }, tableHead.map((val, key) => getTableCell(row, val, key))));
                    })))),
            react_1.default.createElement("div", { className: 'mobile-data-container' }, invoices.map((el, i) => react_1.default.createElement(billingItem_1.default, { key: i, data: el }))))));
};
const mapStateToProps = (state) => {
    const { subscription } = state;
    return {
        subscription
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getList: () => dispatch(subscriptionSlice_1.getList()),
        showLoader: () => dispatch(preloaderSlice_1.showLoader()),
        hideLoader: () => dispatch(preloaderSlice_1.hideLoader())
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(BillingHistory);
